import nBossConnection from 'modules/base/service/nBossConnection';
import DeviceSelectionDto from '../dto/DeviceSelectionDto';

class DeviceService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'deviceControl';
	}

	/**
	 * @return {Promise<DeviceSelectionDto[]>}
	 */
	findAllSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/findAllSelection`)
				.then(response => resolve(response.data !== null ? response.data.map(d => new DeviceSelectionDto().setup(d)) : null))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<DeviceSelectionDto>}
	 */
	findById(id) {
		return new Promise((resolve, reject) => {
			this.connection.post(`/${this.CONTROL}/findById`, { id }).then(response => resolve(response.data)).catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {number} projectId
	 * @param {string} location
	 * @param {number} deviceTypeId
	 * @return {Promise<Object>}
	 */
	accept(id, projectId, location, deviceTypeId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/accept`, {
					id,
					projectId,
					location,
					deviceTypeId,
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	reject(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/reject`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
	
	/**
	 * @param {number} id
	 * @return {Promise<Object>}
	 */
	setToPending(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setToPending`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new DeviceService();